export default "__VITE_ASSET__ZAfEY1NU__"